<template>
  <Card class="page-disease">
    <div style="display: flex; margin-bottom: 15px">
      <div style="flex: 1; display: flex">
        <el-input
          v-model="keywords"
          placeholder="请输入关键字搜索"
          style="max-width: 350px"
          @keyup.enter.native="getQueryList"
        />
        <el-button type="primary" round style="margin-left: 30px" @click="getQueryList">搜索</el-button>
      </div>
      <el-button type="primary" round style="margin-left: 230px" @click="add">新增诊断</el-button>
      <el-button type="primary" round style="margin-left: 20px" @click="showExcelModal">导入模版</el-button>
    </div>
    <Table :columns="columns" :data="dataSource" :loading="loading">
      <template slot-scope="{ row }" slot="action">
        <el-button type="text" style="margin-right: 10px" @click="edit(row)">编辑</el-button>
        <el-popconfirm title="确定删除该诊断吗？" @confirm="remove(row)">
          <el-button slot="reference" type="text" class="error">删除</el-button>
        </el-popconfirm>
      </template>
    </Table>
    <div style="margin-top: 16px; text-align: right">
      <Page
        :total="total"
        :current="page"
        :page-size="size"
        :page-size-opts="sizes"
        :show-total="true"
        :show-elevator="true"
        :show-sizer="true"
        @on-change="onCurrentChange"
        @on-page-size-change="onSizeChange"
      />
    </div>
    <Modal v-model="show" :mask-closable="false" width="550" @on-cancel="cancel">
      <div slot="header" style="text-align: center">
        <span>{{cur.id ? '编辑诊断' : '新增诊断'}}</span>
      </div>
      <Form
        ref="form"
        :model="cur"
        :label-width="150"
        :rules="rule"
        label-position="right"
        style="margin-left: -40px;margin-right: 40px"
      >
        <FormItem label="诊断名称" prop="diagnosis_name">
          <Input
            v-model.trim="cur.diagnosis_name"
            :disabled="read"
            :maxlength="30"
            placeholder="请填写诊断名称"
          ></Input>
        </FormItem>
        <FormItem label="诊断编码" prop="icd_diagnosis_code">
          <Input
            v-model.trim="cur.icd_diagnosis_code"
            :disabled="read"
            :maxlength="30"
            placeholder="请填写诊断编码"
          ></Input>
        </FormItem>
        <FormItem label="诊断类型" prop="diagnosis_type">
          <Input
            v-model.trim="cur.diagnosis_type"
            :disabled="read"
            :maxlength="30"
            placeholder="请填写诊断类型"
          ></Input>
        </FormItem>
        <FormItem label="拼音码" prop="pin_code">
          <Input v-model.trim="cur.pin_code" :disabled="read" :maxlength="30" placeholder="请填写拼音码"></Input>
        </FormItem>
        <FormItem label="五笔码" prop="wb_code">
          <Input v-model.trim="cur.wb_code" :disabled="read" :maxlength="30" placeholder="请填写五笔码"></Input>
        </FormItem>
        <FormItem label="简拼码" prop="spell_code">
          <Input
            v-model.trim="cur.spell_code"
            :disabled="read"
            :maxlength="30"
            placeholder="请填写简拼码"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer" style="text-align: center">
        <el-button v-if="!read" type="info" round @click="cancel">取消</el-button>
        <el-button v-if="!read" type="primary" round :loading="modalLoading" @click="save">保存</el-button>
      </div>
    </Modal>

    <Modal
      v-model="show_excel"
      :styles="{ top: '25%' }"
      footer-hide
      title="导入对象"
      :z-index="999"
      @on-cancel="hideExcelModal"
    >
      <div>
        <div style="margin-bottom: 20px">
          <span>
            <i class="el-icon-warning-outline"></i>仅允许导入"xlsx"或"xls"格式文件
          </span>
          <span style="color: #2d8cf0; cursor: pointer;" @click="downloadExcel">下载模板</span>
        </div>
        <Upload
          :multiple="false"
          type="drag"
          ref="upload"
          accept=".xlsx, .xls"
          :before-upload="handleUpload"
          :on-success="handleSuccess"
          :on-error="handleError"
          :headers="{
            Authorization: 'Bearer ' + $store.state.access_token,
            tenant: $store.state.tenant.tenant
          }"
          :action="DIAG_IMPORT"
          :show-file-list="false"
        >
          <div style="padding: 20px 0">
            <img src="../../images/icon_wuwj.png" alt style="width:140px" />
            <p>将文件拖拽到此处，或点击上传</p>
          </div>
        </Upload>
      </div>
    </Modal>
  </Card>
</template>
<script>
import {
  DIAG_IMPORT,
  DIAGNOSIS_EXCEL,
  FAST_UPLOAD,
  CARINGFAST,
} from '../../utils/env'
import {
  getDiagListApi,
  updateDiagApi,
  addDiagApi,
  deleteDiagApi,
} from '../../api/diagnosis'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      show_excel: false,
      DIAG_IMPORT,
      keywords: '',
      columns: [
        {
          title: 'ID',
          align: 'center',
          key: 'id',
        },
        {
          title: '诊断名称',
          align: 'center',
          key: 'diagnosis_name',
        },
        {
          title: '诊断编码',
          align: 'center',
          key: 'icd_diagnosis_code',
        },
        {
          title: '诊断类型',
          align: 'center',
          key: 'diagnosis_type',
        },
        {
          title: '五笔码',
          align: 'center',
          key: 'wb_code',
        },
        {
          title: '拼音码',
          align: 'center',
          key: 'pin_code',
        },
        {
          title: '简拼码',
          align: 'center',
          key: 'spell_code',
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action',
        },
      ],
      dataSource: [],
      cur: {},
      rule: {
        diagnosis_name: [
          {
            required: true,
            message: '请填写诊断名称',
            trigger: 'blur',
          },
          {
            required: true,
            message: '请填写诊断名称',
            trigger: 'change',
          },
          // {
          //   pattern: /^[\u4e00-\u9fa5_()（）a-zA-Z0-9]+$/,
          //   message: '请输入由中英文、数字、括号以及下划线组成的诊断名称',
          //   trigger: 'blur',
          // },
          // {
          //   pattern: /^[\u4e00-\u9fa5_()（）a-zA-Z0-9]+$/,
          //   message: '请输入由中英文、数字、括号以及下划线组成的诊断名称',
          //   trigger: 'change',
          // },
        ],
        icd_diagnosis_code: [
          {
            required: true,
            message: '请填写诊断编码',
            trigger: 'blur',
          },
          {
            required: true,
            message: '请填写诊断编码',
            trigger: 'change',
          },
          // {
          //   pattern: /^\w+$/,
          //   message: '请输入由数字、字母以及下划线组成的诊断编码',
          //   trigger: 'blur',
          // },
          // {
          //   pattern: /^\w+$/,
          //   message: '请输入由数字、字母以及下划线组成的诊断编码',
          //   trigger: 'change',
          // },
        ],
      },
      read: false,
      loading: false,
      show: false,
      modalLoading: false,
      total: 0,
      page: 1,
      size: 10,
      sizes: [10, 20, 30, 40, 50],
    }
  },
  computed: {
    ...mapGetters(['shift']),
  },
  created() {
    this.getList()
  },
  methods: {
    showExcelModal() {
      this.$refs.upload.clearFiles()
      this.show_excel = true
    },
    hideExcelModal() {
      this.show_excel = false
    },
    handleUpload() {
      this.$refs.upload.clearFiles()
    },
    handleSuccess(res) {
      if (res.code === 0) {
        this.$message.success('上传成功！')
        this.getList()
      } else {
        this.$message.error(res.message)
      }
    },
    handleError(res) {
      this.$refs.upload.clearFiles()
    },
    downloadExcel() {
      location.href = DIAGNOSIS_EXCEL
    },
    onCurrentChange(current) {
      this.page = current
      this.getList()
    },
    onSizeChange(size) {
      this.size = size
      this.getList()
    },
    getQueryList() {
      this.page = 1
      this.getList()
    },
    getList() {
      this.loading = true
      const { page, size, keywords } = this
      getDiagListApi({
        page,
        size,
        keywords,
        institution_id: this.shift.institution_id,
      })
        .then((res) => {
          this.loading = false
          if (res.code === 0) {
            this.dataSource = res.data
            this.total = res['x-total-count'] || res.data.length
            if (this.total && !this.dataSource.length && this.page > 1) {
              this.page = this.page - 1
              this.getList()
            }
          } else {
            this.$Message.error(res.message)
          }
        })
        .catch(() => (this.loading = false))
    },
    showModal() {
      this.show = true
    },
    add() {
      this.cur = {
        diagnosis_name: '',
        icd_diagnosis_code: '',
        institution_id: this.shift.institution_id,
        institution_name: this.shift.institution_name,
        // create_user_id: this.$store.state.user.user.id,
      }
      this.showModal()
    },
    edit(row) {
      this.cur = JSON.parse(JSON.stringify(row))
      this.showModal()
    },
    remove(row) {
      let obj = {
        id: row.id,
      }
      deleteDiagApi(obj).then((res) => {
        if (res.code === 0) {
          this.$Message.success('删除成功')
          this.getList()
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    cancel() {
      this.$refs.form.resetFields()
      this.show = false
      this.modalLoading = false
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.modalLoading = true
          if (this.cur.id) {
            updateDiagApi(this.cur).then((res) => {
              this.modalLoading = false
              if (res.code === 0) {
                this.cancel()
                this.getList()
              } else {
                this.$Message.error(res.message)
              }
            })
          } else {
            addDiagApi(this.cur).then((res) => {
              this.modalLoading = false
              if (res.code === 0) {
                this.cancel()
                this.getList()
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        }
      })
    },
  },
}
</script>
<style lang="less">
.page-disease {
  .error {
    color: #f56c6c;
    &:focus,
    &:hover {
      color: #f78989;
    }
  }
}
</style>
